export default __webpack_public_path__ + "static/media/icons8-pencil-96.459992f6.svg";